module.exports = __webpack_public_path__ + "img/visa-logo-light.65d0cba2.svg";